import * as React from 'react'

import { Box, Grid, IconButton } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import AppSearchBar from '../../../features/apps/AppComponents/AppSearchBar/AppSearchBar'
import {
  LogOutButton,
  MyAlertsAndNotifications,
  VisitorModeLabel,
} from './DashboardLocalButtons'
import ReorderFavoriteAppsListIconButton from '../../../features/apps/AppComponents/ReorderFavoriteAppsList/ReorderFavoriteAppsListIconButton'

// TODO Add back sensitive info toggle (Should do with login updates)
export default function MyAppsLocalButtons({
  classes,
  isMobile,
  history,
  dispatch,
  userProfile,
  activeAlerts,
  activeNotificationList,
  dialogOpen,
}) {
  const isGuest =
    localStorage.getItem('user') === '"visitor"' ||
    localStorage.getItem('user') === ''

  return (
    <Grid item sm={4} md={4}>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        style={{ flexWrap: 'nowrap' }}
      >
        {!isMobile ? (
          <Grid item style={{ marginRight: 4 }}>
            <VisitorModeLabel classes={classes} />
          </Grid>
        ) : null}
        {!isGuest && (
          <Grid item>
            <Box display="flex">
              <ReorderFavoriteAppsListIconButton />
            </Box>
          </Grid>
        )}
        {!isMobile && (
          <Grid item className={classes.searchBarContainer} md={5}>
            <AppSearchBar />
          </Grid>
        )}
        <MyAlertsAndNotifications
          dispatch={dispatch}
          isMobile={isMobile}
          isGuest={isGuest}
          classes={classes}
          activeAlerts={activeAlerts}
          activeNotificationList={activeNotificationList?.length}
          dialogOpen={dialogOpen}
        />
        {isMobile && (
          <Grid item>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Settings Menu"
              onClick={() => history.push('/settings')}
            >
              <SettingsIcon className={classes.appBarIcon} />
            </IconButton>
          </Grid>
        )}
        <LogOutButton
          isMobile={isMobile}
          dispatch={dispatch}
          userProfile={userProfile}
          classes={classes}
          history={history}
        />
      </Grid>
    </Grid>
  )
}
